import { motion } from "framer-motion";
import "../../index.css";
import CustomLists from "@/components/elements/CustomLists/CustomLists";
import ImageWithContentLeftForProduct from "@/components/elements/ImageWithContent/ImageWithContentLeftForProduct";
import Paragraph from "@/components/elements/Paragraph/Paragraph";
import Table from "@/components/elements/Table/Table";
import TitleBar from "@/components/elements/TitleBar/TitleBar";
import TitleWithContent from "@/components/elements/TitleWithContent/TitleWithContent";
import vistapowersilicafumeImg from '@/assets/images/products/vistapowersilicafume.png';

const fadeInUp = {
  initial: { opacity: 0, y: 40 },
  whileInView: { opacity: 1, y: 0 },
  transition: { duration: 0.6, ease: "easeOut" },
  viewport: { once: true, amount: 0.2 },
};

const VistaPowerSilicaFume = () => {
  return (
    <div className=" 2xl:px-40 xl:px-40 md:px-[3rem] sm:px-5 my-[4rem] ">
      <TitleBar
        title="Vista Power Silica Fume"
        subTitle="(Hybrid Technology Silica Fume)"
      />

      <motion.div {...fadeInUp}>
        <ImageWithContentLeftForProduct alt="Vista Power Silica Fume"
          imageUrl={vistapowersilicafumeImg}
          title="Description"
          content="VISTA PowerX Silica Fume is a densified silica fume designed to produce extremely strong, durable concrete. It complies with ASTM C 1240 specifications."
        />
      </motion.div>

      <motion.div {...fadeInUp}>
        <TitleWithContent title="Advantages">
          <Paragraph content="VISTA PowerX contains extremely fine (0.15 μm) latently reactive silicon dioxide, offering the following benefits:" />
          <CustomLists
            items={[
              [
                "Increased concrete strength.",
                "Extended concrete service life.",
                "Better water retention and higher set density.",
                "Improved internal cohesion and pumping properties.",
                "Enhanced water tightness and durability.",
              ],
              [
                "Superior surface finish.",
                "Reduced chloride diffusion.",
                "Higher resistance to abrasion and chemical attacks.",
                "Ideal for structures exposed to aggressive environments.",
              ],
            ]}
          />
        </TitleWithContent>
      </motion.div>

      <motion.div {...fadeInUp}>
        <TitleWithContent title="Properties">
          <Table
            items={{
              headings: [],
              rows: [
                ["Color", "Grey to dark grey powder"],
                ["Density", "> 500 Kg/m³ (densified)"],
                ["Specific Surface Area", "> 15 m²/g"],
                ["Specific Gravity", "2.2"],
              ],
            }}
          />
        </TitleWithContent>
      </motion.div>

      <motion.div {...fadeInUp}>
        <TitleWithContent title="Technical Data">
          <Table
            items={{
              headings: [],
              rows: [
                ["SiO₂", "> 89%"],
                ["Alkalis as Na₂O", "< 1.5%"],
                ["Loss on Ignition", "< 4%"],
                ["Moisture Content", "< 3%"],
              ],
            }}
          />
        </TitleWithContent>
      </motion.div>

      <motion.div {...fadeInUp}>
        <TitleWithContent title="Area of Application">
          <Paragraph content="VISTA PowerX is used to produce high-performance concrete with enhanced durability and strength. It is ideal for:" />
          <CustomLists
            items={[
              ["Structural concrete requiring high strength."],
              ["Infrastructure exposed to aggressive environments."],
            ]}
          />
        </TitleWithContent>
      </motion.div>

      <motion.div {...fadeInUp}>
        <TitleWithContent title="Application">
          <Paragraph content="Using VISTA PowerX enables the production of premium-grade concrete. Standard good concreting practices regarding mixing, placing, and curing must be followed." />
        </TitleWithContent>
      </motion.div>

      <motion.div {...fadeInUp}>
        <TitleWithContent title="Health and Safety Information">
          <Paragraph content="For guidelines on safe handling, storage, and disposal, refer to the latest Material Safety Data Sheet (MSDS) containing physical, ecological, toxicological, and safety-related data." />
        </TitleWithContent>
      </motion.div>
    </div>
  );
};

export default VistaPowerSilicaFume;
